import React,{useEffect, useState} from 'react'
import appDownloadIcon from '../../assets/images/app-download.svg'
import googlePlayIcon from '../../assets/images/Google-Play.svg'
import appStoreIcon from '../../assets/images/App-Store.svg'
import airPlaneIcon from '../../assets/images/airplain.svg'
import SiteMap from './SiteMap';
import GeoLocation from './../../components/geolocation'



export default function Home() {
  
    return (
      <>
        <GeoLocation />
        <section className="Homepage-wrapper">
          <div className="container">
            <div className="Homepage">
              <div className="home-img-head">
                  <h1><span>EZ Leisure</span> gives<br /> you <span>safe</span> and<span> convenient</span> parking for your RV and<br /> Boat</h1>
                  <div className="comman-btn">
                    <button onClick={() => document.getElementById('bookNow').focus()}>Book now</button>
                  </div>
                </div>
            </div>
          </div>
        </section>
        <section className="Download-App-wrap">
          <div className="container">
            <div className="Download-App">
              <div className="Download-App-mobile-img">
                 <img src={appDownloadIcon} />
              </div>
              <div className="Download-App-info">
                <h2>Download Our Mobile App:</h2>
                <div className="app-images">
                  <img src={googlePlayIcon} alt="" />
                  <img src={appStoreIcon} alt="" />
                </div>
                <p>Gain immediate access to your vehicle using our convenient app. Once you create a profile and book a spot with EZ Leisure you will
                  have access to your vehicle at any time. </p>
              </div>
            </div>

         <div className="who-we-are">
          <div className="who-we-are-info">
            <h2>WHO WE ARE</h2>
            <p>EZ Leisure provides a safe parking location with 24 hour monitoring for your boat or RV.  Our convenient app and website tools allow you to have immediate access to your vehicle. Mange your bookings, edit your vehicle and personal profile information, update your payment info, schedule onsite vehicle maintenance or report facility issues with ease. </p>
            <a className='link' onClick={(e) => setTimeout(() =>{
                  var bookNow = document.getElementById('bookNow');
                  bookNow && bookNow.focus();
              }, 1000)}>Click here to schedule a tour</a>
          </div>
          <div className="Download-App-airplain-img">
            <img  src={airPlaneIcon} />
          </div>
       </div>
      </div>
    </section>
    
    <section id='bookNow' tabIndex="1" className="booking-parking-wrap">
        <SiteMap />
    </section>
      </>
    )
}
